// extracted by mini-css-extract-plugin
export var numpadContainer = "_pd-1";
export var phoneButton = "_pd-0";